/* FS header: mega menu (hover + click/keyboard), mobile drawer, sticky offset */
(() => {
  const header = document.querySelector('[data-fs-header]');
  if (!header) return;

  const setHeight = () => {
    const section = header.closest('.fs-header-section') || header;
    document.documentElement.style.setProperty('--fs-header-height', `${section.offsetHeight}px`);
  };
  setHeight();
  window.addEventListener('resize', setHeight);

  /* ---- Mega menu ---- */
  const items = [...header.querySelectorAll('[data-mega]')];
  const closeAll = (except) => {
    items.forEach((it) => {
      if (it === except) return;
      it.classList.remove('is-open');
      it.querySelector('[data-mega-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  };
  const open = (it) => {
    closeAll(it);
    it.classList.add('is-open');
    it.querySelector('[data-mega-toggle]')?.setAttribute('aria-expanded', 'true');
  };
  const close = (it) => {
    it.classList.remove('is-open');
    it.querySelector('[data-mega-toggle]')?.setAttribute('aria-expanded', 'false');
  };
  const isTouch = window.matchMedia('(hover: none)').matches;

  items.forEach((it) => {
    let timer;
    if (!isTouch) {
      it.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        timer = setTimeout(() => open(it), 60);
      });
      it.addEventListener('mouseleave', () => {
        clearTimeout(timer);
        timer = setTimeout(() => close(it), 120);
      });
    }
    const toggle = it.querySelector('[data-mega-toggle]');
    toggle?.addEventListener('click', (e) => {
      e.preventDefault();
      it.classList.contains('is-open') ? close(it) : open(it);
    });
    if (isTouch) {
      const link = it.querySelector('.fs-nav__link');
      link?.addEventListener('click', (e) => {
        if (!it.classList.contains('is-open')) {
          e.preventDefault();
          open(it);
        }
      });
    }
    it.addEventListener('focusout', (e) => {
      if (!it.contains(e.relatedTarget)) close(it);
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
  document.addEventListener('click', (e) => {
    if (!header.contains(e.target)) closeAll();
  });

  /* ---- Mobile drawer ---- */
  const drawer = document.querySelector('[data-drawer]');
  const openBtn = header.querySelector('[data-drawer-open]');
  if (drawer && openBtn) {
    const openDrawer = () => {
      drawer.hidden = false;
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      document.body.classList.add('fs-drawer-open');
      openBtn.setAttribute('aria-expanded', 'true');
      drawer.querySelector('[data-drawer-close]')?.focus();
    };
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      document.body.classList.remove('fs-drawer-open');
      openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(() => (drawer.hidden = true), 300);
      openBtn.focus();
    };
    openBtn.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ---- Mobile search toggle ---- */
  const searchOpen = header.querySelector('[data-search-open]');
  const searchInput = header.querySelector('.fs-search__input');
  if (searchOpen && searchInput) {
    searchOpen.addEventListener('click', (e) => {
      e.preventDefault();
      header.classList.toggle('fs-header--search-open');
      if (header.classList.contains('fs-header--search-open')) searchInput.focus();
    });
  }
})();
